module.exports = __webpack_public_path__ + "fonts/Montserrat-Black.27e3649b.ttf";